<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    const modalAction = () => {
        dispatch("modalAction")
    }
    import "../header/header.css";
    import ConnectButton from "../ConnectButton.svelte";
    import {POLYGEN_STATIC_SITE_BASE_URL} from "../../constants/constants";
    let mainLogo = "./images/logo.svg";
    export let activeMobile = false;
</script>
<div class="header-wrapper flex items-center">
    <a href={POLYGEN_STATIC_SITE_BASE_URL}>
        <img class="header-logo" src={mainLogo} alt="logo">
    </a>
    <div class="open-menu-btn" class:activeMobile on:click={()=> activeMobile = !activeMobile}>
        <span class="bar-one"></span>
        <span class="bar-two"></span>
        <span class="bar-three"></span>
    </div>
    <div class="button-wrapper flex items-center flex-text-center ml-auto" class:activeMobile>
        <nav class="navigation-wrap flex">
            <ul class="list-none flex">
                <li><a href="https://polygen.io/">Home</a></li>
                <li><a href="https://polygen.io/#about">About</a></li>
                <li><a href="https://polygen.io/#our-solution">Our Solution</a></li>
                <li><a href="https://polygen.io/#how-it-works">How it Works</a></li>
                <li><a href="https://polygen.io/#eco-system">Polygen Eco-System</a></li>
                <li><a href="https://polygen.io/#team">Team</a></li>
                <li><a href="https://polygen.io/#road">Roadmap</a></li>
                <li><a href="https://tiers.polygen.io/" target="_blank">Tiers</a></li>

            </ul>
        </nav>
        <ConnectButton/>
    </div>
</div>
